/**
 * Utilidades para manejar JWT tokens
 */

/**
 * Decodifica un token JWT y extrae el payload
 * @param {string} token - El token JWT
 * @returns {object|null} - El payload decodificado o null si hay error
 */
export const decodeJwt = (token) => {
  try {
    // Un JWT tiene 3 partes separadas por puntos: header.payload.signature
    const parts = token.split('.');
    
    if (parts.length !== 3) {
      console.error('Token JWT inválido: debe tener 3 partes');
      return null;
    }
    
    // Decodificar la segunda parte (payload) que está en base64
    const payload = parts[1];
    
    // Agregar padding si es necesario para base64
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
    
    // Decodificar de base64 a string y luego parsear como JSON
    const decodedPayload = atob(paddedPayload.replace(/-/g, '+').replace(/_/g, '/'));
    const parsedPayload = JSON.parse(decodedPayload);
    
    return parsedPayload;
  } catch (error) {
    console.error('Error al decodificar JWT:', error);
    return null;
  }
};

/**
 * Extrae el ID de la institución desde un token JWT
 * @param {string} token - El token JWT
 * @returns {number|null} - El ID de la institución o null si no se encuentra
 */
export const getInstitutionIdFromToken = (token) => {
  const payload = decodeJwt(token);
  
  if (!payload) {
    return null;
  }
  
  // Verificar que el payload tenga el campo 'id'
  if (!payload.id) {
    console.error('Token JWT no contiene el campo "id"');
    return null;
  }
  
  // Convertir a número y verificar que sea válido
  const institutionId = parseInt(payload.id);
  
  if (isNaN(institutionId)) {
    console.error('El campo "id" del token no es un número válido');
    return null;
  }
  
  return institutionId;
};

/**
 * Verifica si un token JWT es válido (no expirado)
 * @param {string} token - El token JWT
 * @returns {boolean} - true si el token es válido, false en caso contrario
 */
export const isTokenValid = (token) => {
  const payload = decodeJwt(token);
  
  if (!payload) {
    return false;
  }
  
  // Verificar si el token tiene expiración
  if (payload.exp) {
    const currentTime = Math.floor(Date.now() / 1000);
    if (currentTime > payload.exp) {
      console.error('Token JWT expirado');
      return false;
    }
  }
  
  return true;
}; 